import { FC } from 'react';
import { css, Theme, useTheme } from '@emotion/react';
import { CheckCircle } from '@phosphor-icons/react';
import { Empty, EmptyProps } from 'client/components/Empty';
import { Confetti } from 'client/components/Other/Confetti';
import { borderRadius } from 'client/Theme';

const emptyStyle = (theme: Theme) => css`
  position: relative;
  padding: 64px 0;
  background-color: ${theme.color.primary[60]};
  border-radius: ${borderRadius}px;

  > span {
    margin-bottom: 0 !important;
  }

  > canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: ${borderRadius}px;
    pointer-events: none;
  }
`;

export type SuccessBannerProps = EmptyProps;

export const SuccessBanner: FC<SuccessBannerProps> = ({ children, ...props }) => {
  const theme = useTheme();
  return (
    <Empty icon={<CheckCircle size={64} color={theme.color.secondary[100]} />} css={emptyStyle} {...props}>
      {children}
      <Confetti />
    </Empty>
  );
};
